module.exports = __webpack_public_path__ + "static/media/6-item-e.aa1ef5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/6-item-e.jpg
// module id = 1205
// module chunks = 33